<template lang="html">
  <!--<div class="page-admin show-cards-in-sequence&#45;&#45; show-cards-up&#45;&#45;">-->
    <!--<navbar-component/>-->

    <!--<dashboard-component>-->
      <div class="col-12">
        <div class="row">
          <card-component alert :block="false" :col="{xs: 12}">
            <banner-component/>
          </card-component>
        </div>
        <div class="row">
          <card-component :col="{xs: 6, lg:3}">
            <div class="text-poppins">
              <h2 class="display-4 mb-4 text-center text-info">{{ stats.transactionsCount }}</h2>
              <p class="h5 text-center">Financiamentos iniciados</p>
            </div>
          </card-component>
          <card-component :col="{xs: 6, lg:3}">
            <div class="text-poppins">
              <h2 class="display-4 mb-4 text-center text-info">{{ stats.transactionsSentCount }}</h2>
              <p class="h5 text-center">Propostas enviadas</p>
              <small class="d-block mt-2 text-center text-muted">{{ stats.transactionsSentPerc }}% do total</small>
            </div>
          </card-component>
          <card-component :col="{xs: 6, lg:3}">
            <div class="text-poppins">
              <h2 class="display-4 mb-4 text-center text-info">{{ stats.transactionsSignedCount }}</h2>
              <p class="h5 text-center">Contratos assinados</p>
              <small class="d-block mt-2 text-center text-muted">{{ stats.transactionsSignedPerc }}% do total</small>
            </div>
          </card-component>
          <card-component :col="{xs: 6, lg:3}">
            <div class="text-poppins">
              <h2 class="display-4 mb-4 text-center text-info">{{ stats.contractCount }}</h2>
              <p class="h5 text-center">Vendas</p>
              <small class="d-block mt-2 text-center text-muted">{{ stats.contractPerc }}% do total</small>
            </div>
          </card-component>
        </div>
        <div class="row">
          <card-component style="min-height: calc(100vh - 300px);" :block="false" title="Users" subtitle="" :col="{xs: 12}" @onselect="selecionouOpcao"
                          :select="[{id: null,name: 'Últimos cadastros'},{id: 'first',name: 'Mais antigos'}]">
            <transactions-component :refreshList="refreshList" :orderList="orderList"></transactions-component>
          </card-component>
        </div>
      </div>

    <!--</dashboard-component>-->

    <!--<background-component :bg="appbg"/>-->
    <!-- <background-component bg="/static/bgs/2.jpg"/> -->
  <!--</div>-->

</template>

<script>
import Card from '../../partial/card/Card.vue'
import Navbar from '../../partial/navbar/Navbar.vue'
import Dashboard from '../../partial/dashboard/Dashboard.vue'
import Background from '../../partial/background/Background.vue'
import Input from '../../partial/form/Input.vue'
import Login from '../../partial/cards/login/Login.vue'
import Button from '../../partial/button/Button.vue'
import Banner from '../../partial/cards/banner/Banner.vue'
import Transactions from '../../partial/transactions/Transactions.vue'

export default {
  components: {
    'card-component': Card,
    'navbar-component': Navbar,
    'dashboard-component': Dashboard,
    'background-component': Background,
    'login-component': Login,
    'button-component': Button,
    'input-component': Input,
    'banner-component': Banner,
    'transactions-component': Transactions
  },
  data () {
    return {
      avatarimage: '',
      appbg: '/static/bgs/2.jpg',

      refreshList: null,
      orderList: null,
      stats: {
        transactionsCount: 0,
        transactionsSentCount: 0,
        transactionsSentPerc: 0,
        transactionsSignedCount: 0,
        transactionsSignedPerc: 0,
        contractCount: 0,
        contractPerc: 0
      },

      linkReport: process.env.API + '/api/users/report?exportFormat=excel&extension=xls'
    }
  },
  methods: {
    setAppBg (image) {
      this.appbg = image
    },
    setAvatarImage (image) {
      this.avatarimage = image
    },
    selecionouOpcao (value) {
      this.orderList = value
      this.refreshList = (this.refreshList === null) ? true : !this.refreshList
    },
    getStats () {
      this.$http.get('api/me/stats')
        .then(function (res) {
          console.log(res)
          this.stats = res.data
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    }
  },
  mounted () {
    this.getStats()
    this.$ga.page('/#/admin')
  }
}

</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/variaveis.scss";
  @import "../../../assets/scss/card.scss";

</style>



// WEBPACK FOOTER //
// src/components/pages/transactions/TransactionList.vue